import React from "react";
import { cn } from "../../lib/utils";

/**
 * GlassPanel — frosted-glass surface for sticky headers and overlays.
 * Variants: light (default, white tint) and dark (forest green tint).
 */
export default function GlassPanel({
  variant = "light",
  className,
  children,
  ...props
}) {
  return (
    <div
      className={cn(
        variant === "light" ? "glass-panel" : "glass-dark",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
